import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content" }

import LeftSideBar from "./components/LeftSideBar.vue";
import BuyVIPDialogues from "@/components/Dialogues/BuyVIPDialogues.vue";
import UserServiceDialogue from "@/components/Dialogues/UserServiceDialogue.vue";
import LogoutDialogues from "@/components/Dialogues/LogoutDialogues.vue";
import ChatBase from "@/components/Dialogues/Chat/ChatBase.vue";
import LoginDialogue from "@/components/Dialogues/LoginDialogue.vue";
import EditChatTitleDialogue from "@/components/Dialogues/EditChatTitleDialogue.vue";
import DeleteChatHistoryDialogue from "@/components/Dialogues/DeleteChatHistoryDialogue.vue";

import { isExpand } from "@/views/Home/useData/useHomePage";
import { ref, watch, computed } from "vue";
import { getDeviceWidth } from "@/utils/device";
import { isCompactMode } from "@/data/pubilc";
import LeftSideBarDrawer from "@/views/Home/components/LeftSideBarDrawer.vue";
import CustomPopup from "@/components/custom-popup/customPopup.vue";
import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import {
  init,
  dialogueStatus,
  dialogueList,
} from "@/views/Home/useData/module/dialogue";
import { bindDialogue } from "@/views/Home/useData/module/chat";
import { ElMessage } from "element-plus";
import { initChat } from "@/views/Home/useData/module/chat";
import { resetInputBar } from "@/components/Dialogues/useData/useInputBar";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const { isLogin } = storeToRefs(publicStore());

const deviceWidth = getDeviceWidth();

bindDialogue("dialogueStatus", dialogueStatus);
bindDialogue("dialogueList", dialogueList);

watch(deviceWidth, () => {
  const newWidth = deviceWidth.value;
  isCompactMode.value = newWidth <= 680;
  if (newWidth > 1000) {
    isExpand.value = true;
  } else if (newWidth <= 1000) {
    isExpand.value = false;
  }
});

watch(
  isLogin,
  () => {
    if (isLogin.value) {
      setTimeout(() => {
        init();
      }, 1000);
    }
  },
  {
    immediate: true,
  }
);

const sessionId = computed(() => {
  return dialogueStatus.sessionId;
});

watch(
  sessionId,
  (nVal) => {
    const curDialogue = dialogueList.find((dialogue) => {
      const sid = (dialogue as any).session_id;
      return sid === nVal;
    });
    console.log("watch sessionId ", sessionId);
    console.log("curDialogue", curDialogue);
    initChat(sessionId.value, curDialogue);

    //重制对话框
    resetInputBar();
  },
  {
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "page-base" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_main, { class: "p0" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_unref(isCompactMode))
              ? (_openBlock(), _createBlock(LeftSideBar, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(ChatBase)
          ])
        ]),
        _: 1
      }),
      _createVNode(BuyVIPDialogues),
      _createVNode(UserServiceDialogue),
      _createVNode(LogoutDialogues),
      _createVNode(LoginDialogue),
      _createVNode(EditChatTitleDialogue),
      _createVNode(DeleteChatHistoryDialogue),
      (_unref(isCompactMode))
        ? (_openBlock(), _createBlock(LeftSideBarDrawer, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(CustomPopup)
    ]),
    _: 1
  }))
}
}

})